<template>
  <div class="p-6 space-y-6">
    <h1 class="text-2xl font-bold">Lead Sessions</h1>
    <div class="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
      <SessionCard
        v-for="session in sessions"
        :key="session.sessionId"
        :session="session"
      />
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import SessionCard from '../components/crm/sessionCard.vue'

const sessions = ref([
  {
    sessionId: 'sess_vmvxdesmq',
    leadName: 'Mariam',
    createdAt: '2025-06-17T06:59:56.217Z',
    messages: [
      { role: 'assistant', content: 'Hello Mariam! How can I assist you today?' },
      { role: 'user', content: "What's next?" },
      { role: 'user', content: "He's just testing out" },
      { role: 'user', content: '' },
      { role: 'user', content: '' },
      { role: 'user', content: '' },
      { role: 'user', content: 'How are you going to slay this?' },
      { role: 'user', content: 'Goodbye.' },
    ],
    summary: 'The user initiates a conversation with a vague question...',
    totalTokens: 139,
    totalCost: 0.0013,
    status: 'New',
  },
  // Add more sessions here as needed
])
</script>
